import React from "react";
import { useSelector } from "react-redux";
import infoAvatar from "../../../assets/images/Chat-avatar.png";
import { getLiveStream } from "../../../store/social/social.selector";
import { getImage } from "../../../store/user/user.selector";

const userInfo = [
    {
        id: 0,
        name: "Ronald Richards",
        avatar: infoAvatar,
        message: "Hi",
        title: "Test 4 Person",
        info: "Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Quisque faucibus justo quis nunc consequat, vitae malesuada lectus porttitor.",
    },
];

const Info = () => {
    const { livestream } = useSelector((state) => {
        return {
            livestream: getLiveStream(state),
        };
    });
    return (
        <div className="h-[calc(100vh_-_175px)] overflow-y-auto">
            <div key={livestream._id} className="mb-2.5">
                <div className="flex items-center justify-start px-1 mt-4 mb-5">
                    <img
                        src={getImage(livestream.owner.attachments)}
                        alt=""
                        className="rounded-full w-[35px] aspect-square mr-2.5"
                    />
                    <div className="">
                        <h4 className="text-sm font-medium text-black-color capitalize">
                            {livestream.owner.fullName}
                        </h4>
                        <p className="text-[10px] text-black-50">
                            {livestream.owner.userName}
                        </p>
                    </div>
                </div>
                <div className="">
                    <h4 className="text-sm font-medium text-black mb-0.5">
                        {livestream.title}
                    </h4>
                    <p className="text-sm font-normal text-black-50">
                        {livestream.contents}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Info;
